import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchLanguagesList, SummaryLanguage } from "../data/helpers/languages";

const LanguagesContext = createContext<SummaryLanguage[] | undefined>(undefined);

export const useLanguages = () => {
  const context = useContext(LanguagesContext);
  //console.log("LanguagesContext value:", context);
  if (context === undefined) {
    throw new Error("useLanguages must be used within a LanguagesProvider");
  }
  return context;
};

export const LanguagesProvider = ({ children }: { children: React.ReactNode }) => {
  const [languages, setLanguages] = useState<SummaryLanguage[]>([]);

  useEffect(() => {
    fetchLanguagesList()
      .then(data => setLanguages(data))
      .catch(err => console.error("Error fetching languages:", err));
  }, []);

  return (
    <LanguagesContext.Provider value={languages}>
      {children}
    </LanguagesContext.Provider>
  );
};